import { render, staticRenderFns } from "./PreorderView.vue?vue&type=template&id=55b98f41&scoped=true"
import script from "./PreorderView.vue?vue&type=script&lang=js"
export * from "./PreorderView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b98f41",
  null
  
)

export default component.exports